export default __webpack_public_path__ + "static/media/kf.3de28c85.jpg";